<template>
    <div>
        <LayoutHeader>
            <template #custom-user-actions>
                <AccountMenu />
                <HeaderCart />
            </template>
        </LayoutHeader>
        <LayoutNotifications />
        <main class="checkout-main safe-area-inline">
            <slot />
        </main>
        <LayoutFooter />
    </div>
</template>

<style>
    @import '~/assets/scss/checkout/checkout.scss';
</style>
